// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__changelog__ChangeLogAccordion__root","accordionRoot":"CentricUI__changelog__ChangeLogAccordion__accordionRoot","summaryContent":"CentricUI__changelog__ChangeLogAccordion__summaryContent","accordionDetailsRoot":"CentricUI__changelog__ChangeLogAccordion__accordionDetailsRoot","infiniteScroll":"CentricUI__changelog__ChangeLogAccordion__infiniteScroll","expandIcon":"CentricUI__changelog__ChangeLogAccordion__expandIcon","stickyAccordionHeader":"CentricUI__changelog__ChangeLogAccordion__stickyAccordionHeader","count":"CentricUI__changelog__ChangeLogAccordion__count"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/changelog/ChangeLogAccordion.css
// module id = 1726
// module chunks = 10